import {feedbackError, white} from '../sass/base/_exports.sass';

export const AlertFillIcon = ({
  color = feedbackError,
  backgroundColor = white,
  className = '',
  ratio = 1,
}) => {
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
    >
      <path
        d="M14-24.5h4v17h-4z"
        style={{strokeWidth: 1.11029}}
        transform="scale(1 -1)"
        fill={backgroundColor}
      />
      <path
        d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16Zm-1.6-11.2V24h3.2v-3.2Zm0-12.8v9.6h3.2V8Z"
        style={{strokeWidth: 0.853333}}
        fill={color}
      />
    </svg>
  );
};
